(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["elv-panel"] && !Shopify.designMode) return;
  try {
    
if(!customElements.get('elv-expand'))customElements.define('elv-expand',class extends HTMLElement{connectedCallback(){const b=this.querySelector('[data-expand]');if(b)b.addEventListener('click',()=>{const open=b.getAttribute('aria-expanded')==='true';this.querySelectorAll('[data-extra]').forEach(e=>e.hidden=open);b.setAttribute('aria-expanded',String(!open));b.textContent=open?'Zobacz cały skład ↓':'Pokaż mniej ↑'})}});
if(!customElements.get('elv-faq'))customElements.define('elv-faq',class extends HTMLElement{connectedCallback(){const buttons=[...this.querySelectorAll('[data-category]')];buttons.forEach((b,i)=>{b.addEventListener('click',()=>{buttons.forEach(x=>{x.setAttribute('aria-selected',String(x===b));x.tabIndex=x===b?0:-1});this.querySelectorAll('[data-faq-panel]').forEach(x=>x.hidden=x.dataset.faqPanel!==b.dataset.category)});b.addEventListener('keydown',e=>{let n;if(e.key==='ArrowRight')n=(i+1)%buttons.length;else if(e.key==='ArrowLeft')n=(i+buttons.length-1)%buttons.length;else return;e.preventDefault();buttons[n].click();buttons[n].focus()})})}});

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["elv-product"] && !Shopify.designMode) return;
  try {
    
if(!customElements.get('elv-product'))customElements.define('elv-product',class extends HTMLElement{connectedCallback(){if(this.ready)return;this.ready=true;this.slides=[...this.querySelectorAll('[data-slide]')];this.thumbs=[...this.querySelectorAll('[data-show]')];this.current=0;this.thumbs.forEach(b=>b.addEventListener('click',()=>this.showSlide(Number(b.dataset.show))));const stage=this.querySelector('.elv-gallery-stage');let x=0;stage.addEventListener('touchstart',e=>{x=e.changedTouches[0].clientX},{passive:true});stage.addEventListener('touchend',e=>{const d=e.changedTouches[0].clientX-x;if(Math.abs(d)>45)this.showSlide((this.current+(d<0?1:-1)+this.slides.length)%this.slides.length)},{passive:true});const tabs=[...this.querySelectorAll('[data-tab]')];tabs.forEach((b,i)=>{b.addEventListener('click',()=>this.tab(b));b.addEventListener('keydown',e=>{let k=i;if(e.key==='ArrowRight')k=(i+1)%tabs.length;else if(e.key==='ArrowLeft')k=(i+tabs.length-1)%tabs.length;else if(e.key==='Home')k=0;else if(e.key==='End')k=tabs.length-1;else return;e.preventDefault();tabs[k].click();tabs[k].focus()})});this.querySelectorAll('.elv-offer input').forEach(r=>r.addEventListener('change',()=>{this.querySelector('[data-sticky-price]').textContent=r.dataset.price}));this.observer=new IntersectionObserver(e=>{this.querySelector('.elv-sticky').hidden=e[0].isIntersecting||e[0].boundingClientRect.top>0},{threshold:0});this.observer.observe(this.querySelector('.elv-purchase'));const form=this.querySelector('form[action*="/cart/add"]');if(form)form.addEventListener('submit',async e=>{e.preventDefault();const b=form.querySelector('[type=submit]'),status=form.querySelector('[data-status]');const label=b.textContent;b.disabled=true;try{const response=await fetch(this.dataset.root+'cart/add.js',{method:'POST',headers:{Accept:'application/json'},body:new FormData(form)});const json=await response.json();if(!response.ok)throw Error(json.description||'Nie udało się dodać produktu.');window.location.assign(this.dataset.root+'cart')}catch(err){status.textContent=err.message;b.disabled=false;b.textContent=label}})}showSlide(n){this.current=n;this.slides.forEach((s,i)=>s.hidden=i!==n);this.thumbs.forEach((b,i)=>b.setAttribute('aria-pressed',String(i===n)))}tab(b){this.querySelectorAll('[data-tab]').forEach(x=>{x.setAttribute('aria-selected',String(x===b));x.tabIndex=x===b?0:-1});this.querySelectorAll('[data-panel]').forEach(p=>p.hidden=p.dataset.panel!==b.dataset.tab)}disconnectedCallback(){this.observer?.disconnect();this.ready=false}});

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["header"]) return;
  try {
    
  class StickyHeader extends HTMLElement {
    constructor() {
      super();
      this.setHeaderHeight = this.setHeaderHeight.bind(this);
    }

    connectedCallback() {
      this.header = document.querySelector('.section-header');
      this.mobileMediaQuery = window.matchMedia('(max-width: 990px)');
      this.headerIsAlwaysSticky =
        this.getAttribute('data-sticky-type') === 'always' ||
        this.getAttribute('data-sticky-type') === 'reduce-logo-size';
      this.headerBounds = {};

      this.setHeaderHeight();

      this.mobileMediaQuery.addEventListener('change', this.setHeaderHeight);

      if (this.headerIsAlwaysSticky) {
        this.header.classList.add('shopify-section-header-sticky');
      }

      this.currentScrollTop = 0;
      this.preventReveal = false;
      this.predictiveSearches = this.querySelectorAll('predictive-search');

      this.onScrollHandler = this.onScroll.bind(this);
      this.hideHeaderOnScrollUp = () => (this.preventReveal = true);

      this.addEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.addEventListener('scroll', this.onScrollHandler, false);

      this.createObserver();
    }

    setHeaderHeight() {
      document.documentElement.style.setProperty('--header-height', `${this.header.offsetHeight}px`);
    }

    disconnectedCallback() {
      this.mobileMediaQuery.removeEventListener('change', this.setHeaderHeight);
      this.removeEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.removeEventListener('scroll', this.onScrollHandler);
    }

    createObserver() {
      let observer = new IntersectionObserver((entries, observer) => {
        this.headerBounds = entries[0].intersectionRect;
        observer.disconnect();
      });

      observer.observe(this.header);
    }

    onScroll() {
      const scrollTop = window.pageYOffset || document.documentElement.scrollTop;

      if ([...this.predictiveSearches].some((predictiveSearch) => predictiveSearch.isOpen)) return;

      if (scrollTop > this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (this.preventHide) return;
        requestAnimationFrame(this.hide.bind(this));
      } else if (scrollTop < this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (!this.preventReveal) {
          requestAnimationFrame(this.reveal.bind(this));
        } else {
          window.clearTimeout(this.isScrolling);

          this.isScrolling = setTimeout(() => {
            this.preventReveal = false;
          }, 66);

          requestAnimationFrame(this.hide.bind(this));
        }
      } else if (scrollTop <= this.headerBounds.top) {
        this.header.classList.remove('scrolled-past-header');
        requestAnimationFrame(this.reset.bind(this));
      }

      this.currentScrollTop = scrollTop;
    }

    hide() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-hidden', 'shopify-section-header-sticky');
      this.closeMenuDisclosure();
      this.closeSearchModal();
    }

    reveal() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-sticky', 'animate');
      this.header.classList.remove('shopify-section-header-hidden');
    }

    reset() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.remove('shopify-section-header-hidden', 'shopify-section-header-sticky', 'animate');
    }

    closeMenuDisclosure() {
      this.disclosures = this.disclosures || this.header.querySelectorAll('header-menu');
      this.disclosures.forEach((disclosure) => disclosure.close());
    }

    closeSearchModal() {
      this.searchModals = this.searchModals || this.header.querySelectorAll('details-modal');
      this.searchModals.forEach((searchModal) => searchModal.close(false));
    }
  }

  // The account `open` event is composed but does not bubble, so listen during capture.
  // Anchor the dialog to the bottom of the account button itself. The header group can be
  // much taller than the button's row (for example, a top-left logo pushes the menu to a
  // second row), so anchoring to the section bottom drops the dialog too low.
  document.addEventListener(
    'open',
    (event) => {
      if (!(event.target instanceof HTMLElement) || !event.target.matches('shopify-account')) return;

      const bottom = Math.max(0, Math.round(event.target.getBoundingClientRect().bottom));
      event.target.style.setProperty('--account-dialog-top', `${bottom}px`);
    },
    true
  );

  customElements.define('sticky-header', StickyHeader);

  } catch(e) { console.error(e); }
})();
})();
